import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { initialiser } from '../../ramen-imports/utilitybelt';

import App from './containers/App.jsx';
import { store } from './store';

class TicketSelectorV2 {
  constructor({ el }) {
    this.container = el;
  }

  init = () => {
    const {
      filterCategoryIds, isBlock, jsonSearch, jsonAvailability,
    } = this.container.dataset;

    createRoot(this.container).render(
      <React.StrictMode>
        <Provider store={store}>
          <App
            isBlock={!!isBlock}
            filterCategories={filterCategoryIds}
            jsonSearch={jsonSearch}
            jsonAvailability={jsonAvailability}
          />
        </Provider>
      </React.StrictMode>,
    );
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, TicketSelectorV2);
